import { reactive } from 'vue'

type SnackbarMessage = {
  id: number
  message: string
  color: string
  icon: string
  timeout: number
}

const state = reactive({
  snackbars: [] as SnackbarMessage[]
})

let idCounter = 0

export function useSnackbar() {
  function toast({
    actionData
  }: {
    actionData?:
      | { error: boolean; message: string; dataError?: any }
      | { error: boolean; message: string; data?: any }
  }) {
    if (!actionData) return

    const timeout = 2000
    const id = ++idCounter

    const newSnackbar: SnackbarMessage = {
      id,
      message: actionData.message,
      color: actionData.error ? 'error' : 'success',
      icon: actionData.error ? 'mdi-alert-octagon-outline' : 'mdi-check-circle-outline',
      timeout
    }

    state.snackbars.push(newSnackbar)

    setTimeout(() => {
      const index = state.snackbars.findIndex((snack) => snack.id === id)
      if (index !== -1) state.snackbars.splice(index, 1)
    }, timeout)
  }

  return {
    snackbars: state.snackbars,
    toast
  }
}
